import TOC_TYPES from '../../constants/tocTypes';

export default function getChaptersFromItems(items) {
  return items.filter((item) => item.type === TOC_TYPES.SUBTITLE);
}
